// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { logout, getCurrentUserId } from "../../utils/auth";
// import { toast } from "react-toastify";
// import AadhaarStatus from "../../components/AadhaarStatus";
// import "../../css/User/Aadhaar.css";
// import { getSidebarMenus } from "../../constants/sidebarMenus";
// import { useProfile } from "../../hook/useProfile";
// import { documentsApi } from "../../api/documentsApi";
// import TopHeader from "../../components/comman/TopHeader";
// import Sidebar from "../../components/comman/Sidebar";
// import { Icon } from "@iconify/react";

// const DOCUMENT_TYPES = [
//   { value: "aadhaar", label: "Aadhaar Card" },
//   { value: "pan", label: "PAN Card" },
//   { value: "voter", label: "Voter ID" },
//   { value: "driving", label: "Driving Licence" },
// ];

// const DOC_CONFIG = {
//   aadhaar: {
//     title: "Aadhaar Verification",
//     numberLabel: "Aadhaar Number",
//     placeholder: "Enter 12-digit Aadhaar number",
//     hasFront: true,
//     hasBack: true,
//   },
//   pan: {
//     title: "PAN Verification",
//     numberLabel: "PAN Number",
//     placeholder: "Enter PAN Number",
//     hasFront: false,
//     hasBack: false,
//     hasSingle: true,
//   },
//   voter: {
//     title: "Voter ID Verification",
//     numberLabel: "Voter ID Number",
//     placeholder: "Enter Voter ID",
//     hasFront: true,
//     hasBack: true,
//   },
//   driving: {
//     title: "Driving Licence Verification",
//     numberLabel: "Licence Number",
//     placeholder: "Enter DL Number",
//     hasFront: true,
//     hasBack: true,
//   },
// };

// function Kyc3() {
//   const currentUserId = getCurrentUserId();
//   const { isProfileInfo } = useProfile();
//   const [showMsgDrawer, setShowMsgDrawer] = useState(false);
//   const feedTYPE = window.location.pathname.includes("/feed/public") ? "public" : "prime";
//   const [feedType, setFeedType] = useState(feedTYPE);
//   const [localAadhaarStatus, setLocalAadhaarStatus] = useState(null);
//   const navigate = useNavigate();
//   const [activeSidebar, setActiveSidebar] = useState("aadhaar");
//   const [showSidebar, setShowSidebar] = useState(true);
//   const sidebarMenus = getSidebarMenus(currentUserId);
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   // const [selectedDoc, setSelectedDoc] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [errors, setErrors] = useState({});

//   const defaultDoc = DOCUMENT_TYPES.find(doc => doc.value === "aadhaar");
//   const [selectedDoc, setSelectedDoc] = useState(defaultDoc);

//   const [form, setForm] = useState({
//     docNumber: "",
//     frontImage: null,
//     backImage: null,
//     singleImage: null,
//   });

//   const MAX_FILE_SIZE = 8 * 1024 * 1024;

//   const handleLogout = () => {
//     logout();
//     navigate("/login", { replace: true });
//   };

//   const handleDocSelect = (doc) => {
//     setSelectedDoc(doc);
//     setDropdownOpen(false);
//     setForm({ docNumber: "", frontImage: null, backImage: null, singleImage: null });
//     setErrors({});
//   };

//   useEffect(() => {
//     if (defaultDoc) {
//       handleDocSelect(defaultDoc);
//     }
//   }, []);
  
//   const handleFileChange = (e, type) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     if (!file.type.startsWith("image/")) {
//       toast.error("Only image files are allowed");
//       return;
//     }
//     if (file.size > MAX_FILE_SIZE) {
//       toast.error("File size should not exceed 8MB");
//       return;
//     }
//     setForm((prev) => ({ ...prev, [type]: file }));
//     setErrors((prev) => ({ ...prev, [type]: "" }));
//   };

//   const validate = () => {
//     const newErrors = {};
//     const config = DOC_CONFIG[selectedDoc?.value];

//     if (!form.docNumber.trim()) {
//       newErrors.docNumber = `Please enter ${config.numberLabel}`;
//     }

//     if (selectedDoc?.value === "aadhaar" && !/^\d{12}$/.test(form.docNumber)) {
//       newErrors.docNumber = "Aadhaar number must be exactly 12 digits";
//     }

//     if (config.hasFront && !form.frontImage) {
//       newErrors.frontImage = "Please upload front image";
//     }
//     if (config.hasBack && !form.backImage) {
//       newErrors.backImage = "Please upload back image";
//     }
//     if (config.hasSingle && !form.singleImage) {
//       newErrors.singleImage = "Please upload document photo";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

// const handleSubmit = async () => {
//     if (!selectedDoc) {
//       toast.error("Please select a document type");
//       return;
//     }
//     if (!validate()) {
//       toast.error("Please fill all details correctly");
//       return;
//     }

//     setLoading(true);
//     try {
//       // ✅ Build FormData with correct field names backend expects
//       const formData = new FormData();

//       // documentType — backend expects this exact field name
//       const docTypeMap = {
//         aadhaar: "AADHAAR",
//         pan: "PAN",
//         voter: "VOTER_ID",
//         driving: "DRIVING_LICENCE",
//       };

//       formData.append("documentType", docTypeMap[selectedDoc.value]);

//       // documentNumber — backend expects this exact field name
//       formData.append("documentNumber", form.docNumber);

//       // Images
//       if (form.frontImage) formData.append("frontImage", form.frontImage);
//       if (form.backImage) formData.append("backImage", form.backImage);
//       if (form.singleImage) formData.append("frontImage", form.singleImage); // PAN single image goes as frontImage

//       await documentsApi.uploadAadhaar(formData);
//       toast.success("Document submitted successfully!");
//       setLoading(false);
//       setLocalAadhaarStatus("REQUESTED");
//     } catch (err) {
//       const errorMsg =
//         err?.response?.data?.error ||
//         err?.response?.data?.message ||
//         "Submission failed. Try again.";
//       toast.error(errorMsg);
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (isProfileInfo?.adhaarVerified === "REQUESTED") {
//       setLocalAadhaarStatus("REQUESTED");
//     }
//   }, [isProfileInfo]);

//   const effectiveAadhaarStatus =
//     localAadhaarStatus !== null ? localAadhaarStatus : isProfileInfo?.adhaarVerified;

//   const config = selectedDoc ? DOC_CONFIG[selectedDoc.value] : null;

//   // Upload box component
//   const UploadBox = ({ type, label }) => {
//     const file = form[type];
//     return (
//       <div
//         className="kyc-upload-box"
//         onClick={() => document.getElementById(`file-${type}`).click()}
//       >
//         <input
//           type="file"
//           id={`file-${type}`}
//           accept="image/*"
//           hidden
//           onChange={(e) => handleFileChange(e, type)}
//         />
//         {file ? (
//           <img
//             src={URL.createObjectURL(file)}
//             alt={label}
//             className="kyc-upload-preview"
//           />
//         ) : (
//           <>
//             <Icon icon="mdi:camera-plus-outline" className="kyc-camera-icon" />
//             <p className="kyc-upload-title">{label}</p>
//             <p className="kyc-upload-subtitle">Tap to capture or select from gallery</p>
//             <button className="kyc-select-btn" type="button">Select File</button>
//           </>
//         )}
//         {errors[type] && <p className="kyc-error">{errors[type]}</p>}
//       </div>
//     );
//   };

//   return (
//     <div className="container-xxl p-0">
//       <div className="feed-page-wrapper">
//         <TopHeader
//           onToggleSidebar={() => setShowSidebar((prev) => !prev)}
//           onOpenMessages={() => setShowMsgDrawer(true)}
//           creditAmount={50}
//           notificationCount={5}
//           messageCount={0}
//         />
//         <div className="prime-layout-container .container-fluid">
//           <div className="row">
//             {!showSidebar && (
//               <div className="left-sidebar-overlay d-md-none" onClick={() => setShowSidebar(true)} />
//             )}
//             <Sidebar
//               showSidebar={showSidebar}
//               sidebarMenus={sidebarMenus}
//               activeSidebar={activeSidebar}
//               feedType={feedType}
//               onNavigate={(item) => {
//                 setActiveSidebar(item.key);
//                 if (item.path) navigate(item.path);
//               }}
//               onLogout={handleLogout}
//             />

//             <div className="col-lg-9 col-md-9 col-12 overflow-auto center-area-container">
//               <div className="kyc-page-wrapper">

//                 {(effectiveAadhaarStatus === "VERIFIED" || effectiveAadhaarStatus === "REQUESTED") ? (
//                   <AadhaarStatus adhaarVerified={effectiveAadhaarStatus} />
//                 ) : (
//                   <>
//                     <h2 className="kyc-page-title">Upload Your Documents</h2>

//                     {/* DOCUMENT DROPDOWN */}
//                     <div className="kyc-dropdown-wrapper">
//                       <div
//                         className="kyc-dropdown-trigger"
//                         onClick={() => setDropdownOpen((prev) => !prev)}
//                       >
//                         <span>{selectedDoc ? selectedDoc.label : "Choose Your Documents"}</span>
//                         <Icon icon="mdi:chevron-down" className={`kyc-chevron ${dropdownOpen ? "open" : ""}`} />
//                       </div>

//                       {dropdownOpen && (
//                         <div className="kyc-dropdown-menu">
//                           {DOCUMENT_TYPES.map((doc) => (
//                             <div
//                               key={doc.value}
//                               className={`kyc-dropdown-item ${selectedDoc?.value === doc.value ? "active" : ""}`}
//                               onClick={() => handleDocSelect(doc)}
//                             >
//                               {doc.label}
//                             </div>
//                           ))}
//                         </div>
//                       )}
//                     </div>

//                     {/* DYNAMIC FORM */}
//                     {selectedDoc && config && (
//                       <div className="kyc-form-section">

//                         {/* NUMBER INPUT */}
//                         <p className="kyc-field-label">{config.numberLabel}</p>
//                         <div className="kyc-input-wrapper">
//                           <Icon icon="mdi:credit-card-outline" className="kyc-input-icon" />
//                           <input
//                             type="text"
//                             className="kyc-input"
//                             placeholder={config.placeholder}
//                             value={form.docNumber}
//                             maxLength={selectedDoc.value === "aadhaar" ? 12 : 20}
//                             onChange={(e) => {
//                               const val = selectedDoc.value === "aadhaar"
//                                 ? e.target.value.replace(/\D/g, "")
//                                 : e.target.value.toUpperCase();
//                               setForm((prev) => ({ ...prev, docNumber: val }));
//                               setErrors((prev) => ({ ...prev, docNumber: "" }));
//                             }}
//                           />
//                         </div>
//                         {errors.docNumber && <p className="kyc-error">{errors.docNumber}</p>}

//                         <p className="kyc-upload-hint">
//                           Please upload clear images of both the front and back sides of your {selectedDoc.label} for secure identity verification
//                         </p>

//                         {/* UPLOAD BOXES */}
//                         {config.hasSingle && (
//                           <UploadBox type="singleImage" label="Document Photo" />
//                         )}

//                         {config.hasFront && config.hasBack && (
//                           <div className="kyc-upload-row">
//                             <UploadBox type="frontImage" label="Front Side" />
//                             <UploadBox type="backImage" label="Back Side" />
//                           </div>
//                         )}

//                         {/* SUBMIT BUTTON */}
//                         <button
//                           className="kyc-submit-btn"
//                           onClick={handleSubmit}
//                           disabled={loading}
//                         >
//                           {loading ? "Submitting..." : "Submit for Verification"}
//                         </button>

//                         <p className="kyc-secure-text">
//                           <Icon icon="mdi:lock-outline" className="me-1" />
//                           Your Data Is Encrypted And Secure
//                         </p>

//                       </div>
//                     )}
//                   </>
//                 )}

//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Kyc3;


// // import React, { useState, useEffect } from "react";
// // import { useNavigate } from "react-router-dom";
// // import { FaArrowLeft, FaTimes, FaCheck } from "react-icons/fa";
// // import { logout, getCurrentUserId } from "../../utils/auth";
// // import { toast } from "react-toastify";
// // import AadhaarStatus from "../../components/AadhaarStatus";
// // // import "../../css/User/Kyc.css";
// // import "../../css/User/Aadhaar.css";
// // import { getSidebarMenus } from "../../constants/sidebarMenus";
// // import { useProfile } from "../../hook/useProfile";
// // import { documentsApi } from "../../api/documentsApi";
// // import TopHeader from "../../components/comman/TopHeader";
// // import Sidebar from "../../components/comman/Sidebar";
// // import Input from "../../components/comman/Input";

// // function Kyc3() {
// //   const currentUserId = getCurrentUserId();
// //   const BASE_URL = process.env.REACT_APP_BASE_URL;
// //   const { isProfileInfo, isLoading } = useProfile();
// //   const [showMsgDrawer, setShowMsgDrawer] = useState(false);
// //   const feedTYPE = window.location.pathname.includes("/feed/public")
// //     ? "public"
// //     : "prime";
// //   const [feedType, setFeedType] = useState(feedTYPE);
// //   const [localAadhaarStatus, setLocalAadhaarStatus] = useState(null);
// //   const navigate = useNavigate();
// //   const [activeSidebar, setActiveSidebar] = useState("aadhaar");
// //   const [showSidebar, setShowSidebar] = useState(true);
// //   const sidebarMenus = getSidebarMenus(currentUserId);

// //   // handle logout
// //   const handleLogout = () => {
// //     logout();
// //     navigate("/login", { replace: true });
// //   };

// //   const [form, setForm] = useState({
// //     aadhaarNumber: "",
// //     frontImage: null,
// //     backImage: null,
// //   });

// //   const [errors, setErrors] = useState({});
// //   const [loading, setLoading] = useState(false);
// //   // const [statusRequested, setStatusRequested] = useState("");

// //   const MAX_FILE_SIZE = 8 * 1024 * 1024;

// //   const handleFileChange = (e, type) => {
// //     const file = e.target.files[0];

// //     if (!file) return;

// //     // Check file type (optional but recommended)
// //     if (!file.type.startsWith("image/")) {
// //       toast.error("Only image files are allowed");
// //       return;
// //     }

// //     // Check file size (10MB max)
// //     if (file.size > MAX_FILE_SIZE) {
// //       toast.error("File size should not exceed 10MB");
// //       return;
// //     }

// //     // Set file
// //     setForm((prev) => ({
// //       ...prev,
// //       [type]: file,
// //     }));

// //     // Clear error if valid
// //     setErrors((prev) => ({
// //       ...prev,
// //       [type]: "",
// //     }));
// //   };

// //   // ========= FORM SUBMISION  ========= //
// //   const handleSubmit = async () => {
// //     if (!validate()) {
// //       toast.error("Please fill all Aadhaar details correctly");
// //       return;
// //     }

// //     setLoading(true);

// //     try {
// //       await documentsApi.uploadAadhaar(form);

// //       toast.success("Aadhaar submitted successfully...");

// //       // STOP LOADING FIRST
// //       setLoading(false);

// //       // FORCE STATUS SWITCH
// //       setLocalAadhaarStatus("REQUESTED");
// //     } catch (err) {
// //       const errorMsg =
// //         err?.response?.data?.error ||
// //         err?.response?.data?.message ||
// //         "Aadhaar verification failed";

// //       toast.error(errorMsg);
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     if (isProfileInfo?.adhaarVerified === "REQUESTED") {
// //       setLocalAadhaarStatus("REQUESTED");
// //     }
// //   }, [isProfileInfo]);

// //   const validate = () => {
// //     const newErrors = {};

// //     if (!/^\d{12}$/.test(form.aadhaarNumber)) {
// //       newErrors.aadhaarNumber = "Aadhaar number must be 12 digits";
// //     }

// //     if (!form.frontImage) {
// //       newErrors.frontImage = "Please upload Aadhaar front image";
// //     }

// //     if (!form.backImage) {
// //       newErrors.backImage = "Please upload Aadhaar back image";
// //     }

// //     if (form.frontImage && form.frontImage.size > MAX_FILE_SIZE) {
// //       newErrors.frontImage = "Front image must be less than 10MB";
// //     }

// //     if (form.backImage && form.backImage.size > MAX_FILE_SIZE) {
// //       newErrors.backImage = "Back image must be less than 10MB";
// //     }

// //     setErrors(newErrors);
// //     return Object.keys(newErrors).length === 0;
// //   };

// //   const effectiveAadhaarStatus =
// //     localAadhaarStatus !== null
// //       ? localAadhaarStatus
// //       : isProfileInfo?.adhaarVerified;

// //   return (
// //     <div className="container-xxl p-0">
// //       <div className="feed-page-wrapper">
// //         <TopHeader
// //           onToggleSidebar={() => setShowSidebar((prev) => !prev)}
// //           onOpenMessages={() => setShowMsgDrawer(true)}
// //           creditAmount={50}
// //           notificationCount={5}
// //           messageCount={0}
// //         />
// //         <div className="prime-layout-container .container-fluid">
// //           <div className="row">
// //             {!showSidebar && (
// //               <div
// //                 className="left-sidebar-overlay d-md-none"
// //                 onClick={() => setShowSidebar(true)}
// //               />
// //             )}

// //             <Sidebar
// //               showSidebar={showSidebar}
// //               sidebarMenus={sidebarMenus}
// //               activeSidebar={activeSidebar}
// //               feedType={feedType}
// //               onNavigate={(item) => {
// //                 setActiveSidebar(item.key);
// //                 if (item.path) {
// //                   navigate(item.path);
// //                 }
// //               }}
// //               onLogout={handleLogout}
// //             />

// //             <div className="col-lg-9 col-md-9 col-12 overflow-auto center-area-container">
// //               {/* ================= KYC PAGE START ================= */}
// //               <div className="Aadhar_page_container col-12">
// //                 <div className="Aadhar_page">
// //                   {/* <div className="kyc-card col-12 col-sm-11 col-md-9"> */}
// //                   <div className="Aadhar_card ">
// //                     <>
// //                       {(effectiveAadhaarStatus === "VERIFIED" ||
// //                         effectiveAadhaarStatus === "REQUESTED") && (
// //                           <AadhaarStatus
// //                             adhaarVerified={effectiveAadhaarStatus}
// //                           />
// //                         )}

// //                       {(effectiveAadhaarStatus === "REJECTED" ||
// //                         effectiveAadhaarStatus === "NONE") && (
// //                           <div className="Aadhar-form shadow">
// //                             <h3 className="theme-color">Aadhaar Details</h3>
// //                             <Input
// //                               name="aadhaarNumber"
// //                               placeholder="Enter 12-digit Aadhaar number"
// //                               className="password-input"
// //                               value={form.aadhaarNumber}
// //                               maxLength={12}
// //                               onChange={(e) =>
// //                                 setForm((prev) => ({
// //                                   ...prev,
// //                                   aadhaarNumber: e.target.value.replace(
// //                                     /\D/g,
// //                                     "",
// //                                   ),
// //                                 }))
// //                               }
// //                             />
// //                             {errors.aadhaarNumber && (
// //                               <p className="error">{errors.aadhaarNumber}</p>
// //                             )}

// //                             <div className="row col-md-gap-3 mt-3">
// //                               <div className="col-12 col-md-6">
// //                                 <div
// //                                   className="aadhaar_upload_box"
// //                                   onClick={() =>
// //                                     document.getElementById("frontImage").click()
// //                                   }
// //                                 >
// //                                   {form.frontImage ? (
// //                                     <img
// //                                       src={URL.createObjectURL(form.frontImage)}
// //                                       alt="Aadhaar Front"
// //                                     />
// //                                   ) : (
// //                                     <span>Upload Aadhaar Front</span>
// //                                   )}
// //                                   <input
// //                                     type="file"
// //                                     id="frontImage"
// //                                     accept="image/*"
// //                                     hidden
// //                                     onChange={(e) => {
// //                                       handleFileChange(e, "frontImage")
// //                                       setForm((prev) => ({
// //                                         ...prev,
// //                                         frontImage: e.target.files[0],
// //                                       }))
// //                                     }
// //                                     }
// //                                   />
// //                                 </div>
// //                                 {errors.frontImage && (
// //                                   <p className="error mt-1">
// //                                     {errors.frontImage}
// //                                   </p>
// //                                 )}
// //                               </div>

// //                               <div className="col-12 mt-3 m-md-0 col-md-6">
// //                                 <div
// //                                   className="aadhaar_upload_box"
// //                                   onClick={() =>
// //                                     document.getElementById("backImage").click()
// //                                   }
// //                                 >
// //                                   {form.backImage ? (
// //                                     <img
// //                                       src={URL.createObjectURL(form.backImage)}
// //                                       alt="Aadhaar Back"
// //                                     />
// //                                   ) : (
// //                                     <span>Upload Aadhaar Back</span>
// //                                   )}
// //                                   <input
// //                                     type="file"
// //                                     id="backImage"
// //                                     accept="image/*"
// //                                     hidden
// //                                     onChange={(e) => {
// //                                       handleFileChange(e, "backImage")
// //                                       setForm((prev) => ({
// //                                         ...prev,
// //                                         backImage: e.target.files[0],
// //                                       }))
// //                                     }

// //                                     }
// //                                   />
// //                                 </div>
// //                                 {errors.backImage && (
// //                                   <p className="error mt-1">{errors.backImage}</p>
// //                                 )}
// //                               </div>
// //                             </div>

// //                             <div className="d-flex justify-content-center mt-3">
// //                               <button
// //                                 className="continue01-btn"
// //                                 onClick={handleSubmit}
// //                                 disabled={loading}
// //                               >
// //                                 {loading ? "Submitting..." : "Submit"}
// //                               </button>
// //                             </div>
// //                           </div>
// //                         )}
// //                     </>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }
// // export default Kyc3;
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { logout, getCurrentUserId } from "../../utils/auth";
import { toast } from "react-toastify";
import AadhaarStatus from "../../components/AadhaarStatus";
import "../../css/User/Aadhaar.css";
import { getSidebarMenus } from "../../constants/sidebarMenus";
import { useProfile } from "../../hook/useProfile";
import { documentsApi } from "../../api/documentsApi";
import TopHeader from "../../components/comman/TopHeader";
import Sidebar from "../../components/comman/Sidebar";
import { Icon } from "@iconify/react";

const AADHAAR_CONFIG = {
  title: "Aadhaar Verification",
  numberLabel: "Aadhaar Number",
  placeholder: "Enter 12-digit Aadhaar number",
  hasFront: true,
  hasBack: true,
};

function Kyc3() {
  const currentUserId = getCurrentUserId();
  const { isProfileInfo } = useProfile();
  const [showMsgDrawer, setShowMsgDrawer] = useState(false);
  const feedTYPE = window.location.pathname.includes("/feed/public") ? "public" : "prime";
  const [feedType, setFeedType] = useState(feedTYPE);
  const [localAadhaarStatus, setLocalAadhaarStatus] = useState(null);
  const navigate = useNavigate();
  const [activeSidebar, setActiveSidebar] = useState("aadhaar");
  const [showSidebar, setShowSidebar] = useState(true);
  const sidebarMenus = getSidebarMenus(currentUserId);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const [form, setForm] = useState({
    docNumber: "",
    frontImage: null,
    backImage: null,
  });

  const MAX_FILE_SIZE = 8 * 1024 * 1024;

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      toast.error("Only image files are allowed");
      return;
    }
    if (file.size > MAX_FILE_SIZE) {
      toast.error("File size should not exceed 8MB");
      return;
    }
    setForm((prev) => ({ ...prev, [type]: file }));
    setErrors((prev) => ({ ...prev, [type]: "" }));
  };

  const validate = () => {
    const newErrors = {};

    if (!form.docNumber.trim()) {
      newErrors.docNumber = `Please enter ${AADHAAR_CONFIG.numberLabel}`;
    }

    if (!/^\d{12}$/.test(form.docNumber)) {
      newErrors.docNumber = "Aadhaar number must be exactly 12 digits";
    }

    if (!form.frontImage) {
      newErrors.frontImage = "Please upload front image";
    }
    if (!form.backImage) {
      newErrors.backImage = "Please upload back image";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) {
      toast.error("Please fill all details correctly");
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();

      formData.append("documentType", "AADHAAR");
      formData.append("documentNumber", form.docNumber);

      if (form.frontImage) formData.append("frontImage", form.frontImage);
      if (form.backImage) formData.append("backImage", form.backImage);

      await documentsApi.uploadAadhaar(formData);
      toast.success("Document submitted successfully!");
      setLoading(false);
      setLocalAadhaarStatus("REQUESTED");
    } catch (err) {
      const errorMsg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        "Submission failed. Try again.";
      toast.error(errorMsg);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isProfileInfo?.adhaarVerified === "REQUESTED") {
      setLocalAadhaarStatus("REQUESTED");
    }
  }, [isProfileInfo]);

  const effectiveAadhaarStatus =
    localAadhaarStatus !== null ? localAadhaarStatus : isProfileInfo?.adhaarVerified;

  // Upload box component
  const UploadBox = ({ type, label }) => {
    const file = form[type];
    return (
      <div
        className="kyc-upload-box"
        onClick={() => document.getElementById(`file-${type}`).click()}
      >
        <input
          type="file"
          id={`file-${type}`}
          accept="image/*"
          hidden
          onChange={(e) => handleFileChange(e, type)}
        />
        {file ? (
          <img
            src={URL.createObjectURL(file)}
            alt={label}
            className="kyc-upload-preview"
          />
        ) : (
          <>
            <Icon icon="mdi:camera-plus-outline" className="kyc-camera-icon" />
            <p className="kyc-upload-title">{label}</p>
            <p className="kyc-upload-subtitle">Tap to capture or select from gallery</p>
            <button className="kyc-select-btn" type="button">Select File</button>
          </>
        )}
        {errors[type] && <p className="kyc-error">{errors[type]}</p>}
      </div>
    );
  };

  return (
    <div className="container-xxl p-0">
      <div className="feed-page-wrapper">
        <TopHeader
          onToggleSidebar={() => setShowSidebar((prev) => !prev)}
          onOpenMessages={() => setShowMsgDrawer(true)}
          creditAmount={50}
          notificationCount={5}
          messageCount={0}
        />
        <div className="prime-layout-container .container-fluid">
          <div className="row">
            {!showSidebar && (
              <div className="left-sidebar-overlay d-md-none" onClick={() => setShowSidebar(true)} />
            )}
            <Sidebar
              showSidebar={showSidebar}
              sidebarMenus={sidebarMenus}
              activeSidebar={activeSidebar}
              feedType={feedType}
              onNavigate={(item) => {
                setActiveSidebar(item.key);
                if (item.path) navigate(item.path);
              }}
              onLogout={handleLogout}
            />

            <div className="col-lg-9 col-md-9 col-12 overflow-auto center-area-container">
              <div className="kyc-page-wrapper">

                {(effectiveAadhaarStatus === "VERIFIED" || effectiveAadhaarStatus === "REQUESTED") ? (
                  <AadhaarStatus adhaarVerified={effectiveAadhaarStatus} />
                ) : (
                  <>
                    <h2 className="kyc-page-title">Upload Your Aadhaar Card</h2>

                    <div className="kyc-form-section">

                      {/* NUMBER INPUT */}
                      <p className="kyc-field-label">{AADHAAR_CONFIG.numberLabel}</p>
                      <div className="kyc-input-wrapper">
                        <Icon icon="mdi:credit-card-outline" className="kyc-input-icon" />
                        <input
                          type="text"
                          className="kyc-input"
                          placeholder={AADHAAR_CONFIG.placeholder}
                          value={form.docNumber}
                          maxLength={12}
                          onChange={(e) => {
                            const val = e.target.value.replace(/\D/g, "");
                            setForm((prev) => ({ ...prev, docNumber: val }));
                            setErrors((prev) => ({ ...prev, docNumber: "" }));
                          }}
                        />
                      </div>
                      {errors.docNumber && <p className="kyc-error">{errors.docNumber}</p>}

                      <p className="kyc-upload-hint">
                        Please upload clear images of both the front and back sides of your Aadhaar Card for secure identity verification
                      </p>

                      {/* UPLOAD BOXES */}
                      <div className="kyc-upload-row">
                        <UploadBox type="frontImage" label="Front Side" />
                        <UploadBox type="backImage" label="Back Side" />
                      </div>

                      {/* SUBMIT BUTTON */}
                      <button
                        className="kyc-submit-btn"
                        onClick={handleSubmit}
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Submit for Verification"}
                      </button>

                      <p className="kyc-secure-text">
                        <Icon icon="mdi:lock-outline" className="me-1" />
                        Your Data Is Encrypted And Secure
                      </p>

                    </div>
                  </>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Kyc3;